import { appUrls } from "./urls/appUrls"

export const navigationStructure = {
	general_navigation: [
		{
			id: 1,
			has_children: false,
			name: 'Dashboard',
			url: appUrls.dashboard,
			icon: 'mdi mdi-wechat',
			mainPath: appUrls.dashboard,
			subPath: [],
			defaultHref: false
		},

		{
			id: 2,
			has_children: false,
			name: 'Home',
			url: appUrls.dashboard,
			icon: 'mdi mdi-wechat',
			mainPath: appUrls.dashboard,
			subPath: [],
			defaultHref: false
		},
		{
			id: 3,
			has_children: false,
			name: 'About Us',
			url: appUrls.dashboard,
			icon: 'mdi mdi-wechat',
			mainPath: appUrls.dashboard,
			subPath: [],
			defaultHref: false
		},
		{
			id: 4,
			has_children: false,
			name: 'Services',
			url: appUrls.dashboard,
			icon: 'mdi mdi-wechat',
			mainPath: appUrls.dashboard,
			subPath: [],
			defaultHref: false
		},
		{
			id: 5,
			has_children: false,
			name: 'FAQs',
			url: appUrls.dashboard,
			icon: 'mdi mdi-wechat',
			mainPath: appUrls.dashboard,
			subPath: [],
			defaultHref: false
		},
		{
			id: 6,
			has_children: false,
			name: 'News',
			url: appUrls.dashboard,
			icon: 'mdi mdi-wechat',
			mainPath: appUrls.dashboard,
			subPath: [],
			defaultHref: false
		},
	
	],

	certicate_management: [
		{
			id: 2,
			has_children: false,
			name: 'Confirmation Requests',
			url: appUrls.certificates,
			icon: 'mdi mdi-file-document',
			subPath: [appUrls.certificates_view, appUrls.transactionHistory],
			defaultHref: false
		},
	
	],

	bank_certicate_management: [
		{
			id: 3,
			has_children: false,
			name: 'Confirmation Requests',
			url: appUrls.bank_certificates,
			icon: 'mdi mdi-file-document',
			subPath: [appUrls.bank_certificates_view, appUrls.transactionHistory],
			defaultHref: false
		},
	
	],

	notap_certicate_management: [
		{
			id: 4,
			has_children: false,
			name: 'Confirmation Requests',
			url: appUrls.notap_certificates,
			icon: 'mdi mdi-file-document',
			subPath: [appUrls.notap_certificates_view, appUrls.transactionHistory],
			defaultHref: false
		},
	
	],

	digital_letter: [
		{
			id: 5,
			has_children: false,
			name: 'Digital Letters',
			url: `${appUrls.digitalLetterBase}`,
			icon: 'mdi mdi-email-mark-as-unread',
			mainPath: appUrls.digital_letters,
			subPath: [],
			defaultHref: false
		},
	
	],
}